import { defineComponent } from 'vue';
import { ToolTip } from '@yellowcard/components-library-vue3';
import enLocale from '@/locale/en.locale';
import useTransactionsStore from '@/store/modules/transactions';
import { useGeneralStore } from '@/store/modules/general';
import { storeToRefs } from 'pinia';
export default defineComponent({
    name: 'BankDetailsComponent',
    components: {
        ToolTip,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const generalStore = useGeneralStore();
        const { collection, channel } = storeToRefs(transactionsStore);
        const { showToast } = generalStore;
        const copyAccountName = async () => {
            if (collection.value?.bankInfo?.accountName) {
                await navigator.clipboard.writeText(collection.value.bankInfo.accountName);
                showToast('Account name copied to clipboard');
            }
        };
        const copyAccountNumber = async () => {
            if (collection.value?.bankInfo?.accountNumber) {
                await navigator.clipboard.writeText(collection.value.bankInfo.accountNumber);
                showToast('Account number copied to clipboard');
            }
        };
        const copyReferenceCode = async () => {
            if (collection.value?.reference) {
                await navigator.clipboard.writeText(collection.value.reference);
                showToast('Reference code copied to clipboard');
            }
        };
        const onKeyPress = () => {
            console.log();
        };
        return {
            collection,
            channel,
            enLocale,
            copyAccountName,
            copyAccountNumber,
            copyReferenceCode,
            onKeyPress,
        };
    },
});
